import src from "IMAGE";
export default { src, width: 1040, height: 586, blurWidth: 0, blurHeight: 0};
